import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import striptags from 'striptags';
import messages from './messages';
import styles from './FreeGiftAOV.module.scss';
import GiftWrapper from '../../../components/GiftWrapper';
import RichTextDisplay from '../../../components/RichTextDisplay/RichTextDisplay';

const FreeGiftAOV = ({
  title,
  description,
  summaryDisclaimer,
  onCloseModal,
  children = null,
  promotionalBanner = false,
}) => {
  const { formatMessage, locale } = useIntl();

  return (
    <div className={styles.container}>
      <div className={styles['flyout-header']}>
        <div className={styles['flyout-title-container']}>
          <div className={styles.title}>{title[locale]}</div>
          {description?.[locale] && striptags(description[locale]).trim() && (
            <div className={styles['flyout-description']}>
              <RichTextDisplay content={description[locale]} />
            </div>
          )}
        </div>
        <button
          aria-label={formatMessage(messages.closeModal)}
          type="button"
          onClick={onCloseModal}
          data-testid="btn__close__modal"
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onCloseModal();
            }
          }}
          id="button1"
        >
          <div className={styles['close-button']} />
        </button>
      </div>
      {promotionalBanner && (
        <div className={styles['promo-banner-block']}>{children}</div>
      )}
      <GiftWrapper summaryDisclaimer={summaryDisclaimer} />
    </div>
  );
};
FreeGiftAOV.propTypes = {
  children: PropTypes.node,
  title: PropTypes.object.isRequired,
  description: PropTypes.object,
  summaryDisclaimer: PropTypes.object,
  onCloseModal: PropTypes.func.isRequired,
  promotionalBanner: PropTypes.bool
};

export default FreeGiftAOV;